import React from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Tooltip, { TooltipProps } from "@mui/joy/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

/** Выше Sidebar (zIndex: 10000), как в TermHint юнит-экономики */
const TOOLTIP_Z_INDEX = 10001;

type FieldHintProps = {
    title: string;
    /** Абзацы пояснения */
    lines: React.ReactNode[];
    /** Примеры: что получит пользователь */
    examples?: React.ReactNode[];
};

/** Иконка «?» рядом с подписью поля; на мобильных открывается по тапу. */
export function FieldHint(props: FieldHintProps) {
    const { title, lines, examples } = props;

    const content = (
        <Box sx={{ maxWidth: 340, p: 0.25, display: "flex", flexDirection: "column", gap: 0.75 }}>
            <Typography level="title-sm" sx={{ color: "common.white" }}>
                {title}
            </Typography>
            {lines.map((line, i) => (
                <Typography key={i} level="body-sm" sx={{ color: "common.white" }}>
                    {line}
                </Typography>
            ))}
            {examples && examples.length > 0 && (
                <Box>
                    <Typography level="body-xs" sx={{ color: "neutral.200", fontWeight: "lg" }}>
                        Примеры
                    </Typography>
                    <Box component="ul" sx={{ m: 0, pl: 2 }}>
                        {examples.map((example, i) => (
                            <Typography key={i} component="li" level="body-xs" sx={{ color: "common.white" }}>
                                {example}
                            </Typography>
                        ))}
                    </Box>
                </Box>
            )}
        </Box>
    );

    return (
        <Tooltip
            title={content}
            variant="solid"
            placement="top"
            enterTouchDelay={0}
            leaveTouchDelay={10000}
            slotProps={{
                root: {
                    sx: {
                        zIndex: TOOLTIP_Z_INDEX,
                        maxWidth: 380,
                    },
                },
            } as TooltipProps["slotProps"]}
        >
            <HelpOutlineIcon
                tabIndex={0}
                aria-label={`Подсказка: ${title}`}
                sx={{ fontSize: 16, ml: 0.5, cursor: "help", opacity: 0.7 }}
            />
        </Tooltip>
    );
}
